import React from 'react'
import { ScreeningQuestion } from '../../../types/sponsorships/campaigns'
import './style.scss'

const PLACEHOLDER = 'Type your answer here...'

const ScreeningQuestionText: React.FC<{
  index: number
  question: ScreeningQuestion
  value: string | number
  onChange: (value: string) => void
}> = ({ index, question, value, onChange }) => {
  const fieldId = `screening-text-${question.id}`

  return (
    <div className="screening-text">
      <h3
        className="screening-text__title fw-600 text-dark fs-16"
        id={`${fieldId}-label`}
      >
        {index + 1}. {question.question}
      </h3>
      <textarea
        id={fieldId}
        className="screening-text__input fw-400 fs-14 text-dark"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={PLACEHOLDER}
        rows={1}
        aria-labelledby={`${fieldId}-label`}
      />
    </div>
  )
}

export default ScreeningQuestionText
